import type { ReactNode, RefObject } from 'react'
import type { SRT_Cell, SRT_RowData, SRT_TableInstance } from '../../types'

export type SRT_TableBodyCellValueProps<TData extends SRT_RowData> = {
	cell: SRT_Cell<TData>
	rowRef?: RefObject<HTMLTableRowElement | null>
	staticColumnIndex?: number
	staticRowIndex?: number
	table: SRT_TableInstance<TData>
}

export const SRT_TableBodyCellValue = <TData extends SRT_RowData>({
	cell,
	rowRef,
	staticColumnIndex,
	staticRowIndex,
	table,
}: SRT_TableBodyCellValueProps<TData>) => {
	/* const { getState } = table */
	const { column, row } = cell
	const { columnDef } = column
	/* 	const { globalFilter, globalFilterFn } = getState()
	const filterValue = column.getFilterValue()
 */
	let renderedCellValue =
		cell.getIsAggregated() && columnDef.AggregatedCell
			? columnDef.AggregatedCell({
					cell,
					column,
					row,
					table,
					staticColumnIndex,
					staticRowIndex,
				})
			: row.getIsGrouped() && !cell.getIsGrouped()
				? null
				: cell.getIsGrouped() && columnDef.GroupedCell
					? columnDef.GroupedCell({
							cell,
							column,
							row,
							table,
							staticColumnIndex,
							staticRowIndex,
						})
					: undefined

	const isGroupedValue = renderedCellValue !== undefined

	if (!isGroupedValue) {
		renderedCellValue = cell.renderValue() as ReactNode | number | string
	}

	if (columnDef.Cell && !isGroupedValue) {
		renderedCellValue = columnDef.Cell({
			cell,
			column,
			renderedCellValue,

			cellValue: cell.getValue() as any,
			row,
			rowRef,
			staticColumnIndex,
			staticRowIndex,
			table,
		})
	}

	return renderedCellValue
}
